// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useEffect } from 'react';
import { NotificationBanner } from '@tls/treact-ui';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchInitializationStatus } from 'store/reducers/projectsSlice';

export default function InitializationBanner() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isInitializing = useAppSelector(s => s.projects.isInitializing);
  // A project is pending (shows a spinner) while it is not yet in the ready set.
  const hasPendingProjects = useAppSelector(s =>
    s.projects.projectsMetadata.some(p => !!p.projectId && !s.projects.readyProjectIds.includes(p.projectId))
  );

  // Seed the banner state once so clients that connect after the SignalR events pick it up.
  useEffect(() => {
    dispatch(fetchInitializationStatus());
  }, [dispatch]);

  // Only show the banner while there is actually something loading (a pending/spinner tile).
  if (!isInitializing || !hasPendingProjects) return null;

  return (
    <NotificationBanner
      kind='info'
      title={t('project.initializing.title')}
      description={t('project.initializing.description')}
      data-testid='initialization-banner'
    />
  );
}
